export default "__VITE_ASSET__DDWWeUXu__"